module.exports = __webpack_public_path__ + "img/mile4m-m@2.f72e0609.webp";